<template>
    <div class="tabs tabs--col3" :class="getTabClass()">
        <div @click="toggleTab('overview')" class="tab__entry" v-bind:class="{'active' : (currentPage != 'support' &&  currentPage != 'rating')}">
            <div class="tab__link">{{$t('title.description')}}</div>
        </div>
        <div @click="toggleTab('support')" class="tab__entry" v-bind:class="{'active' : currentPage == 'support'}">
            <div class="tab__link">{{$t('title.support')}}</div>
        </div>
        <template v-if="$store.state.loggedIn || Object.keys(comments).length > 0">
            <div @click="toggleTab('ratings')" class="tab__entry" v-bind:class="{'active' : currentPage == 'rating'}">
                <div class="tab__link">{{$t('title.rating')}}</div>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'DetailTabs',
        data() {
            return {
                plugin_id_url: window.location.href.split('/')[4],
                plugin_id: window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1),
                page: window.location.href.split('/')[5],
                comments: {},
            }
        },
        props: {
            currentPage: {
                type: String,
                required: false,
            },
        },
        emits: ['toggle-tabs'],
        methods: {
            getTabClass() {
                if(this.$store.state.loggedIn || Object.keys(this.comments).length > 0) {
                    return "tabs--col3";
                } else {
                    return "tabs--col2";
                }
            },
            toggleTab(button) {
                var page = 'overview';
                switch(button) {
                    case "overview":
                        page = 'overview';
                        break;
                    case "ratings":
                        page = 'rating';
                        break;
                    case "support":
                        page = 'support';
                        break;
                }
                this.$router.push({ name: 'Detail', params: { id: this.plugin_id_url, page: page }});

                this.$emit('toggle-tabs', page);
            }
        },
        created() {
                if(this.page == "support") {
                    this.supportActive = true;
                } else if(this.page == "rating") {
                    this.ratingsActive = true;
                } else {
                    this.overviewActive = true;
                }
                
            var pluginInfo = new FormData();
            pluginInfo.append('plugin', this.plugin_id);
            pluginInfo.append('plugin_id', this.plugin_id);

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadComments',
                data: pluginInfo,
            }).then(response => {
                console.log(response.data);
                this.comments = response.data;
            });
        },
    }
</script>

<style scoped>
    .tabs{
        display: flex;
    }

    .tabs .tab__entry{
        width: 50%;
        text-align: center;
        margin: 0 20px;
        cursor: pointer;
    }

    .tabs--col3 .tab__entry{
        width: calc(100% / 3);
    }

    .tabs .tab__entry .tab__link{
        font-size: 23px;
        line-height: 32px;
        display: inline-block;
        padding: 0 20px;
        border-bottom: 4px solid #FFFFFF;
        padding-bottom: 5px;
    }

    .tabs .tab__entry.active .tab__link{
        border-bottom: 4px solid #E73246;
        font-weight: bold;
    }
</style>